export default __webpack_public_path__ + "static/sprive-logo-red-7d7c22ccf54969894d09ac779e6a400e.png";